

import Datetime from 'vux/src/components/datetime/index.vue'

import moment from 'moment'

export default {
name: 'canlendar',
components: {
Datetime,
moment
},
data () {
return {
currentYear: 1970, // 年份
currentMonth: 1, // 月份
currentDay: 1, // 日期
currentWeek: 1, // 星期
days: [],
date: '',
visibility: false,
selectedDay: '',
today: true,
currentDate: ''
}
},
created () {
this.initData(null)
this.date = this.currentDate
},
watch: {
date (value) {
this.$emit('pick-date', value)
}
},
methods: {
formatDate (year, month, day) {
const y = year
let m = month
if (m < 10) m = `0${m}`
let d = day
if (d < 10) d = `0${d}`
return `${y}-${m}-${d}`
},
formatTime (time) {
const currentDay = moment(time).get('date')
const currentYear = moment(time).get('year')
const currentMonth = moment(time).get('month') + 1
const currentDate = this.formatDate(currentYear, currentMonth, currentDay)
return currentDate
},

initData (selectedDate) {
let date = ''
if (selectedDate) {
date = selectedDate
} else {
date = moment().format()
}
this.currentDay = moment(date).get('date')
this.currentYear = moment(date).get('year')
this.currentMonth = moment(date).get('month') + 1
this.currentWeek = moment(date).day() 
if (this.currentWeek === 0) {
this.currentWeek = 7
}
const str = this.formatTime(date)
if (!selectedDate) {
this.currentDate = str 
}
this.days.length = 0

/* eslint-disabled */
for (let i = this.currentWeek - 1; i >= 0; i -= 1) {
const d = new Date(str)
d.setDate(d.getDate() - i)
this.pushDay(d)
}
for (let i = 1; i <= 7 - this.currentWeek; i += 1) {
const d = new Date(str)
d.setDate(d.getDate() + i)
this.pushDay(d)
}
},


weekPre () {
let d = this.days[0].day
d = new Date(d)
d.setDate(d.getDate() - 7)
this.initData(d)
},


weekNext () {
let d = this.days[0].day
d = new Date(d)
d.setDate(d.getDate() + 7)
this.initData(d)
},


pick (model, index) {
console.log(222222, model)


let d = Number(model.day.split('-')[1])
console.log('ddd', d)
this.currentMonth = d

const formatDate = this.formatTime(model.day)
if (this.currentDate === formatDate) {
this.today = true
} else {
this.today = false
}
this.selectedDay = model.day
this.date = formatDate
},
onConfirm (time) {
console.log(1111, time)
if (this.currentDate !== time) {
this.today = false
} else {
this.today = true
}
this.selectedDay = time
this.initData(time)
},
prev () {
this.selectedDay = ''
this.today = false
this.weekPre()
},
next () {
this.selectedDay = ''
this.today = false
this.weekNext()
},
pushDay (day) {
let dayInfo = {
day: '',
isNextMonth: false,
isToday: false,
isSelected: false
}
const currentDay = moment(day).get('date')
const currentYear = moment(day).get('year')
const currentMonth = moment(day).get('month') + 1
const currentDate = this.formatDate(currentYear, currentMonth, currentDay)
dayInfo.day = currentDate
if (currentMonth !== this.currentMonth) {
dayInfo.isNextMonth = true
}
if (currentDate === this.currentDate) {
dayInfo.isToday = true
}
if (this.formatTime(this.selectedDay) === currentDate) {
dayInfo.isSelected = true
}
this.days.push(dayInfo)
},
dateClick () {
this.visibility = true
}
},
filters: {
day: function (value) {
if (!value) return ''
value = moment(value).get('date')
return value
}
}

}



// WEBPACK FOOTER //
// ./src/components/calendar/index.vue